import { render, staticRenderFns } from "./shippingCampare.vue?vue&type=template&id=5ceb5e2f"
import script from "./shippingCampare.vue?vue&type=script&lang=js"
export * from "./shippingCampare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ceb5e2f')) {
      api.createRecord('5ceb5e2f', component.options)
    } else {
      api.reload('5ceb5e2f', component.options)
    }
    module.hot.accept("./shippingCampare.vue?vue&type=template&id=5ceb5e2f", function () {
      api.rerender('5ceb5e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/shippingCharges/components/shippingCampare.vue"
export default component.exports